/**
 * **plain テーマの盤の描き方**（Issue #523）。**文字と線だけ**。
 *
 * 2 つ目のテーマとして、`core/theme` の契約が本当に実装を分離できているかの**検算**を兼ねる。
 * arcade（格ゲー風）と違うのは:
 *
 * - **マットの地（`matBack`）とマットの枠線（`matFront`）を持たない** ——
 *   `core/theme` の層の一覧には在るが、この表に無い層は**描かれない**（画面のスライダーも無効になる）
 * - カードは盤ではなく**オブジェクトの層**（`drawObjects.js`）
 *
 * 元動画（`video`）だけは arcade とほぼ同じ —— 「平面に中心を合わせて置いて平面で切る」以外の
 * 置き方が無いため。共有したい部分（`centerToPlane`）は `core/field` にある。
 */
import { quadPath } from '../../canvas/paint';
import { videoPlaneRect } from '../../core/field';

/** 元動画。平面に置いて平面で切る（両端の手札の帯は落ちる） */
export function drawLiveField(ctx, scene) {
  const el = scene.video?.el;
  const size = scene.video?.size;
  if (!el || !(size?.w > 0) || !(size?.h > 0)) return;
  if (typeof el.readyState === 'number' && el.readyState < 2) return;
  const { w, h } = scene.field.plane;
  // 要素が元の映像の一部だけ（描く側は平面に入る部分だけ渡す。Issue #808）でも、置く場所は元の映像の座標で決まる
  const r = videoPlaneRect(scene.video, scene.field.plane);
  ctx.save();
  ctx.beginPath();
  ctx.rect(0, 0, w, h);
  ctx.clip();
  ctx.drawImage(el, r.x, r.y, r.w, r.h);
  ctx.restore();
}

/** ゾーンの枠。**細い白線だけ**（種類で色を変えない） */
export function drawZoneLines(ctx, scene, config = {}) {
  const { field } = scene;
  field.keys.forEach((key) => {
    const quad = field.zonePlane(key);
    if (!quad) return;
    quadPath(ctx, quad);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.55)';
    ctx.lineWidth = 2;
    ctx.stroke();
    if (!config?.zoneLabels) return;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
    ctx.font = '20px sans-serif';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';
    ctx.fillText(key, quad[0][0] + 4, quad[0][1] + 22);
  });
}

/**
 * 層の名前 → 描き方。**`matBack` と `matFront` は持たない**（＝ このテーマでは描かれない）。
 * 知らない名前を書くと `toTheme()` が例外にする（綴り間違いを黙って「描かない」にしない）。
 */
export default Object.freeze({
  video: drawLiveField,
  lines: drawZoneLines,
});
